module.exports = __webpack_public_path__ + "img/approve.192bc1ad.png";